import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';
import { useGetMyBDPocsQuery } from 'src/hooks/user.hooks';

const BdPocFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const bdPoc = JSON.parse(searchParams.get('bdPoc') || '[]');

	const { data: myBDPOCsData } = useGetMyBDPocsQuery();
	const bdOptions = myBDPOCsData?.bds?.map(bd => ({ label: `${bd.name} - ${bd.email}`, value: bd._id }));

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!bdPoc?.length}
					placeholder={'Bd'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{bdOptions?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: bdPoc?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (bdPoc?.includes(option?.value?.toString())) {
											searchParams.set(
												'bdPoc',
												JSON.stringify(bdPoc?.filter((skill: string) => skill !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('bdPoc', JSON.stringify([...bdPoc, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{bdPoc?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">BdPoc</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Javascript"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={bdOptions}
						value={bdOptions?.filter(option => bdPoc?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('bdPoc', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default BdPocFilterInput;
